import { CoreIcon } from '../core-icon';
import parkingLotFillSVG from '../../assets/icons/parking-lot-fill.svg';
import type { IconProps } from '../core-icon';

export const ParkingLotFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={parkingLotFillSVG} {...props} />;
};
